import { useCuisineFiltersActions } from './useCuisineFiltersActions';
import { useCuisineFiltersState } from './useCuisineFiltersState';

export const useCuisineFiltersReducer = () => ({
  ...useCuisineFiltersActions(),
  isShowing: useCuisineFiltersState(),
});
